// JSON-LD builders. Pages pass the pieces they have (FAQs, a product name);
// <Seo> assembles them so the markup is written in exactly one place.
import { SITE_URL, SITE_NAME, LANG, absoluteUrl } from './site';

const PUBLISHER = { '@type': 'Organization', name: 'Raya Software Solutions', url: `${SITE_URL}/` };

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  inLanguage: LANG,
  publisher: PUBLISHER,
  // No SearchAction: the site has no search.
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
});

export const breadcrumbSchema = (trail) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: trail.map((t, i) => ({ '@type': 'ListItem', position: i + 1, name: t.name, item: absoluteUrl(t.path) })),
});

export const softwareSchema = ({ name, subCategory, description, path, extra = {} }) => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name,
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: subCategory,
  operatingSystem: 'Web',
  url: absoluteUrl(path),
  description,
  publisher: PUBLISHER,
  ...extra,
});
